import { Navigate, Outlet } from "react-router-dom";
import useAuthStore from "../../context/useAuthStore";

export function RequireUnauth() {
  const { accessToken } = useAuthStore();
  const isAuthenticated = Boolean(accessToken);

  if (isAuthenticated) {
    // Redirect to dashboard if already authenticated
    return <Navigate to="dashboard" replace />;
  }

  return <Outlet />;
}
